import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import React, { useDebugValue } from 'react';
import { useLazyLoad } from '@applyboard/ab-common';
import { getApplicationVerifiedDocumentsAction } from "../../../api/jsonapi";
import { useSetPageMeta } from '@applyboard/ui-utils';
import ApplicationDisplay from "./ApplicationDisplay";
var Application = function Application(props) {
  var _application$program, _application$school, _application$program2;
  var application = props.application;
  var programName = (application === null || application === void 0 ? void 0 : (_application$program = application.program) === null || _application$program === void 0 ? void 0 : _application$program.name) || null;
  var schoolName = (application === null || application === void 0 ? void 0 : (_application$school = application.school) === null || _application$school === void 0 ? void 0 : _application$school.name) || null;
  var programId = (application === null || application === void 0 ? void 0 : (_application$program2 = application.program) === null || _application$program2 === void 0 ? void 0 : _application$program2.id) || null;
  useSetPageMeta({
    title: programName && schoolName ? "".concat(programName, ", ").concat(schoolName) : ''
  });
  useDebugValue(programId);
  useLazyLoad(getApplicationVerifiedDocumentsAction, function (fn) {
    return fn({
      id: props.applicationId
    });
  });
  return /*#__PURE__*/React.createElement(ApplicationDisplay, props);
};
export default Application;